import { timer as observableTimer, Subject, Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class NotificationsService {
  private notification_subject = new Subject<any>();
  private isGranted = false;
  private Notification = window["Notification"];

  constructor(private http: HttpClient) {
    // this.check();
  }

  check() {
    const that = this;
    if (
      navigator.userAgent.toString().indexOf("Chrome") === -1 &&
      navigator.userAgent.toString().indexOf("Firefox") === -1
    ) {
      console.log("Notifications are not yet supported for your browser");
    } else if (
      this.Notification &&
      this.Notification["permission"] !== "granted"
    ) {
      this.Notification.requestPermission()
        .then(function (result) {
          that.isGranted = true;
          console.log(result);
        })
        .catch(function (err) {
          that.isGranted = false;
          console.log(err);
        });
    }
  }

  spawn(title, body, img, link) {
    if (this.isGranted) {
      const n = new Notification(title ? title : "Joinrs", {
        body: body ? body : "",
        icon: img ? img : "assets/favicon/android-icon-192x192.png",
      });
      n.onclick = function (event) {
        event.preventDefault();
        if (link) {
          window.open(link, "_blank");
        }
        n.close();
      };
    }
  }

  getNotifications(): Observable<any> {
    observableTimer(0, 300 * 1000).subscribe(() => {
      this.notification_subject.next(
        this.http.get<any[]>(
          environment.baseUrlWs +
          environment.wsVerison +
          "employer/notifications"
        )
      );
    });
    return this.notification_subject;
  }

  setViewed(id: number) {
    return this.http.post<any[]>(
      environment.baseUrlWs + environment.wsVerison + "employer/notifications",
      {
        notifications_id: id,
      }
    );
  }
}
